module.exports = __webpack_public_path__ + "img/dtc.78a0cca4.png";